export default __webpack_public_path__ + "static/media/pure-heroine.39038e13.jpg";